module.exports = __webpack_public_path__ + "static/media/jakarta-timur.d054b842.svg";